import React, { useEffect, useRef, useState } from 'react';
import './NoteDialog.css';

// Add / edit / clear a free-text note on a single data field. Shared by the
// statutory (chunk 03) and existing-condition (chunk 04) screens so a note
// behaves identically in both.
//
// onSave(text) receives the trimmed note; an empty string means "remove it".
export default function NoteDialog({ name, value = '', onSave, onClose }) {
  const [text, setText] = useState(value || '');
  const taRef = useRef(null);
  const closeRef = useRef(onClose);
  closeRef.current = onClose;

  useEffect(() => {
    taRef.current?.focus();
    const onKey = (e) => { if (e.key === 'Escape') closeRef.current(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  const save = () => onSave(text.trim());

  return (
    <div className="nd-backdrop" onMouseDown={onClose}>
      <div className="nd" role="dialog" aria-modal="true" aria-label={`הערה — ${name}`} onMouseDown={(e) => e.stopPropagation()}>
        <header className="nd-head">
          <h3>הערה — {name}</h3>
          <button type="button" className="nd-x" onClick={onClose} aria-label="סגור">
            <i className="fi fi-rr-cross-small" />
          </button>
        </header>
        <textarea
          ref={taRef}
          className="nd-textarea"
          rows={4}
          value={text}
          onChange={(e) => setText(e.target.value)}
          // Ctrl/Cmd+Enter saves without reaching for the mouse; a bare Enter
          // stays a newline, since these notes run to a couple of sentences.
          onKeyDown={(e) => { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) save(); }}
          placeholder="הוסיפו הערה לנתון…"
        />
        <footer className="nd-foot">
          {value && (
            <button type="button" className="np-btn np-btn-ghost nd-remove" onClick={() => onSave('')}>
              מחק הערה
            </button>
          )}
          <span className="nd-spacer" />
          <button type="button" className="np-btn np-btn-ghost" onClick={onClose}>ביטול</button>
          <button type="button" className="np-btn np-btn-primary" onClick={save}>שמירה</button>
        </footer>
      </div>
    </div>
  );
}
